// extracted by css-extract-rspack-plugin
export default {"dragging":"nEy3Wc"};